const e=(e,n)=>{const t=e.indexOf(n);return-1!==t&&e.splice(t,1),e};export{e as removeFromArray};
//# sourceMappingURL=removeFromArray.min.mjs.map
